import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiModule } from './api.module';
import { BaseApiService } from './base-api.service';
import { CORE_CONFIGURATION } from '../../core/configuration';
import { buildAwsApi, setObjectParams } from '../util.class';
import { Store } from '@ngxs/store';
import { SessionState, SessionStateModel } from '../session';
import { AgreementType } from 'src/app/agreements/shared/agreements.model';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
export class AgreementsApiService {
  keyMapAWS: any;

  constructor(
    private http: BaseApiService,
    private store: Store,
    @Inject(CORE_CONFIGURATION) private config) {
    const { keyMapAWS }: SessionStateModel = this.store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
  }

  /**
   * agreementsByType retrieve agreements values for current user
   * @param customerId customer id
   * @param agreementType C consents O opposition
   */
  agreementsByType(customerId: string, agreementType: string, skipSetup: boolean) {
    const apiAWS = buildAwsApi(
      this.keyMapAWS,
      'retrieve_agreements',
      { customerId, skipSetup, agreementType }
    );

    const apiNotAWS =`/v2/agreements/customer/${customerId}/${agreementType === AgreementType.CONSENTS ? 'consents' : 'oppositions'}?skipCheck=${skipSetup}`;

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS ?? apiNotAWS,
      awsApi: apiAWS !== null
    });
  }

  /**
   * partyPrivacyAgreement save agreements modification
   * @param body input data
   */
  partyPrivacyAgreement(body: any,  hideError = false): Observable<any> {
    // if keyMapAWS is present, we should use it!
    const apiAWS = buildAwsApi(
      this.keyMapAWS,
      'update_agreements',
      {}
    );

    return this.http.post({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS,
      body: body,
      hideError,
      awsApi: apiAWS !== null
    });
  }
}
